module.exports = __webpack_public_path__ + "static/media/item1.2ebe54e9.jpg";